---
fr:
  api_key: Clé API
  api_keys: Clés API
  api_keys_company_access_limit: Affichage des %{count} premiers comptes. Utilisez la recherche pour en trouver d'autres.
  api_keys_confirm_rotate: La rotation du jeton rendra l'ancienne clé invalide. Continuer ?
  api_keys_toast:
    copied: Jeton copié dans le presse-papiers
    create_failed: Impossible de créer la clé API
    created: Clé API créée
    delete_failed: Impossible de supprimer la clé API
    deleted: Clé API supprimée
    export_started: Export lancé - vous recevrez un e-mail lorsqu'il sera prêt
    rotate_failed: Impossible de régénérer le jeton de la clé API
    rotated: Jeton de la clé API régénéré
    update_failed: Impossible de mettre à jour la clé API
    updated: Clé API mise à jour
  api_keys_token_too_short: Le jeton doit contenir au moins {count} caractères
  company_access_hint: Sélectionnez les entreprises auxquelles l'utilisateur API devrait avoir accès
  current_access: Accès actuel
  expensive_req: les requêtes les plus coûteuses des 7 derniers jours
  recent_request: requêtes les plus récentes
